import React from 'react';
import { Box, Grid, Paper, Skeleton, Stack, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import PeopleAltOutlinedIcon          from '@mui/icons-material/PeopleAltOutlined';
import AdminPanelSettingsOutlinedIcon from '@mui/icons-material/AdminPanelSettingsOutlined';
import BusinessOutlinedIcon           from '@mui/icons-material/BusinessOutlined';

const StatCard = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(2),
    borderRadius: theme.shape.borderRadius * 1.5,
    border: `1px solid ${theme.palette.divider}`,
    boxShadow: 'none',
}));

const StatsCards = ({ privileges, vendors, loading }) => {
    const stats = [
        {
            label: 'Configured users',
            value: privileges.length,
            icon:  <PeopleAltOutlinedIcon fontSize="small" />,
        },
        {
            label: 'Admins',
            value: privileges.filter((p) => p.role === 'Admin').length,
            icon:  <AdminPanelSettingsOutlinedIcon fontSize="small" />,
        },
        ...vendors.map((v) => ({
            label: v.name,
            value: privileges.filter((p) => p.vendor === v.name).length,
            icon:  <BusinessOutlinedIcon fontSize="small" />,
        })),
    ];

    return (
        <Grid container spacing={1.5} mb={3}>
            {stats.map((s) => (
                <Grid item xs={6} sm={3} key={s.label}>
                    <StatCard>
                        <Stack direction="row" spacing={1} alignItems="center" mb={0.5}>
                            <Box sx={{ color: 'text.secondary' }}>{s.icon}</Box>
                            <Typography variant="caption" color="text.secondary">{s.label}</Typography>
                        </Stack>
                        {loading
                            ? <Skeleton width={40} height={32} />
                            : <Typography variant="h5" fontWeight={500}>{s.value}</Typography>}
                    </StatCard>
                </Grid>
            ))}
        </Grid>
    );
};

export default StatsCards;